import { Image } from "@chakra-ui/react";
import React from "react";

const PartnerLogo = ({img}) => <Image width="25%" src={img} />;

export default PartnerLogo;
